import {Injectable} from '@angular/core';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {ProviderSummaryModel} from '../providerSummary.model';

@Injectable()
export class ProviderSummaryConverter extends HttpModelConverter<ProviderSummaryModel>{

    protected createInstance(): ProviderSummaryModel {
        return new ProviderSummaryModel();
    }

    protected enrichObject(result: ProviderSummaryModel, src: ProviderSummaryModel) {
    }


}